import {
  collection,
  doc,
  type CollectionReference,
  type DocumentReference,
} from 'firebase/firestore';
import { db } from './firebase';
import type { School, AppUser, Cycle, Review, SchoolDocument, CpdEntry, AppNotification, ObjectiveTemplate, AuditEntry } from '../types';

export const schoolsCol    = collection(db, 'schools')     as CollectionReference<School>;
export const cpdEntriesCol = collection(db, 'cpdEntries') as CollectionReference<CpdEntry>;
export const usersCol = collection(db, 'users') as CollectionReference<AppUser>;
export const cyclesCol = collection(db, 'cycles') as CollectionReference<Cycle>;
export const reviewsCol = collection(db, 'reviews') as CollectionReference<Review>;
export const documentsCol = collection(db, 'documents') as CollectionReference<SchoolDocument>;

export const schoolDoc = (id: string) =>
  doc(db, 'schools', id) as DocumentReference<School>;

export const userDoc = (id: string) =>
  doc(db, 'users', id) as DocumentReference<AppUser>;

export const cycleDoc = (id: string) =>
  doc(db, 'cycles', id) as DocumentReference<Cycle>;

export const reviewDoc = (id: string) =>
  doc(db, 'reviews', id) as DocumentReference<Review>;

export const documentDoc = (id: string) =>
  doc(db, 'documents', id) as DocumentReference<SchoolDocument>;

export const cpdEntryDoc = (id: string) =>
  doc(db, 'cpdEntries', id) as DocumentReference<CpdEntry>;

export const notificationsCol = collection(db, 'notifications') as CollectionReference<AppNotification>;

export const objectiveTemplatesCol = collection(db, 'objectiveTemplates') as CollectionReference<ObjectiveTemplate>;

export const auditLogCol = collection(db, 'auditLog') as CollectionReference<AuditEntry>;
